<div class="media-call-buttons">
  <qai-call-button
    [label]="('call.AUDIO' | transloco)"
    [kind]="isMicOn() ? 'tertiary' : 'destructive'"
    [icon]="isMicOn() ? 'microphone' : 'microphone-off'"
    [disabled]="disableMicButton()"
    (clicked)="handleMicrophoneClick()"
  />

  @if (!hideCameraToggle()) {
    <qai-call-button
      [label]="('call.VIDEO_LABEL' | transloco)"
      [kind]="isVideoOn() && isCameraAvailable() ? 'tertiary' : 'destructive'"
      [icon]="isVideoOn() && isCameraAvailable() ? 'video-recorder' : 'video-recorder-off'"
      [errorBadge]="!isCameraAvailable()"
      (clicked)="handleVideoClick()"
      [matTooltipDisabled]="isCameraAvailable()"
      matTooltipClass="cameraUnavailable"
      [matTooltip]="('call.BROWSER_ACCESS_DENIED' | transloco)"
    />
  }
</div>

<button
  class="endCallButton"
  qai-button
  size="small"
  kind="destructive"
  [disabled]="disableEndCallButton()"
  (click)="handleEndCallClick()"
>
  <qai-icon kind="phone-call" positionStart />
  {{'call.END_CALL' | transloco}}
</button>
